import React from "react";
import { Box, Typography } from "@mui/material";
import { Icon } from "@iconify/react";

/**
 * Shared critique status chip for Completed and OVERDUE_SUBMITTED.
 * Used in AllCritiquesCard, AllCritiquesListView, and CritiqueDetailsHeader.
 *
 * @param {string} status - "completed" | "OVERDUE_SUBMITTED"
 */
const CritiqueStatusChip = ({ status }) => {
  const isOverdueSubmitted = status === "OVERDUE_SUBMITTED";

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        height: 24,
        px: "6px",
        borderRadius: "6px",
        fontWeight: 700,
        fontSize: "12px",
        lineHeight: "20px",
        color: "#118D57",
        bgcolor: "#DBF6E5",
      }}
    >
      {isOverdueSubmitted ? (
        <Icon icon="pajamas:warning-solid" width={16} height={16} style={{ color: "#B76E00" }} />
      ) : (
        <Icon icon="nrk:media-completed" width={16} height={16} style={{ color: "#118D57" }} />
      )}
      <Typography component="span" sx={{ fontWeight: 700, fontSize: "12px", lineHeight: "20px", color: "#118D57" }}>
        Completed
      </Typography>
    </Box>
  );
};

export default CritiqueStatusChip;
